"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        refreshBar: {
            height: '20px',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'flex-end',
            marginBottom: '12px'
        },
        refreshText: {
            paddingLeft: '12px',
            fontSize: '18px'
        }
    });
});
